/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Ex_SquatInputs */

const en_features_ex_squat = /** @type {(inputs: Features_Ex_SquatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barbell back squat`)
};

const pl_features_ex_squat = /** @type {(inputs: Features_Ex_SquatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przysiad ze sztangą`)
};

/**
* | output |
* | --- |
* | "Barbell back squat" |
*
* @param {Features_Ex_SquatInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_ex_squat = /** @type {((inputs?: Features_Ex_SquatInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Ex_SquatInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_ex_squat(inputs)
	return en_features_ex_squat(inputs)
});